export default "__VITE_ASSET__CiqFtjVC__"